import { render, staticRenderFns } from "./Edit_modules.vue?vue&type=template&id=462cbd58&"
import script from "./Edit_modules.vue?vue&type=script&lang=js&"
export * from "./Edit_modules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports